import axios from 'axios'

const http = axios.create({
  baseURL: process.env.VUE_APP_API
})

http.interceptors.request.use((config) => {
  config.headers['access_token'] = process.env.VUE_APP_ACCESS_TOKEN
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default http